export default __webpack_public_path__ + "static/media/icon-aggregator-user.c3463bec.svg";